module.exports = __webpack_public_path__ + "img/mazer-tablet-and-mobile.2972b829.jpg";